import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { CommentForm, FloatingContainer } from '@contently/toolkit';
import useOutsideClick from '../../hooks/useOutsideClick';
import useStoryContext from '../../hooks/useStoryContext';

export default function FloatingCommentForm({ yPos, handleSubmitComment, handleCancelComment }) {
  const formRef = useRef(null);
  const { mentionableUsersBasicInfo } = useStoryContext();
  useOutsideClick(formRef, handleCancelComment);

  return (
    <div ref={formRef}>
      <FloatingContainer right="-372" top={yPos}>
        <CommentForm
          onSubmit={handleSubmitComment}
          onCancel={handleCancelComment}
          users={mentionableUsersBasicInfo}
        />
      </FloatingContainer>
    </div>
  );
}

FloatingCommentForm.propTypes = {
  yPos: PropTypes.number.isRequired,
  handleSubmitComment: PropTypes.func.isRequired,
  handleCancelComment: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/client/components/textEditor/FloatingCommentForm.jsx